export const TabNavegation = (pathName) => {
  
    const tabsHogar = [
        {
            name: "Servicios Internet",
            href: "/cuenta/servicio-de-internet",
            current: pathName === "/cuenta/servicio-de-internet" ? true : false,
        },
        {
            name: "Servicios Televisión",
            href: "/cuenta/servicio-de-television",
            current: pathName === "/cuenta/servicio-de-television" ? true : false,
        },
        {
            name: "Servicios Televisión Streaming",
            href: "/cuenta/servicio-de-streaming",
            current: pathName === "/cuenta/servicio-de-streaming" ? true : false,
        },
        {
            name: "Servicios Telefonía",
            href: "/cuenta/servicio-de-telefonia",
            current: pathName === "/cuenta/servicio-de-telefonia" ? true : false,
        },
        {
            name: "Servicios Salud Integral",
            href: "/cuenta/servicio-de-salud-integral",
            current: pathName === "/cuenta/servicio-de-salud-integral" ? true : false,
        },
    ]
    const tabsEmpresa = [
        {
            name: "Servicios Internet",
            href: "/cuenta/servicio-de-internet",
            current: pathName === "/cuenta/servicio-de-internet" ? true : false,
        },
        {
            name: "Servicios Datos",
            href: "/cuenta/servicio-de-datos",
            current: pathName === "/cuenta/servicio-de-datos" ? true : false,
        },
        {
            name: "Servicios Televisión Streaming",
            href: "/cuenta/servicio-de-streaming",
            current: pathName === "/cuenta/servicio-de-streaming" ? true : false,
        },
        {
            name: "Servicios Telefonía",
            href: "/cuenta/servicio-de-telefonia",
            current: pathName === "/cuenta/servicio-de-telefonia" ? true : false,
        },
        {
            name: "Servicios Salud Integral",
            href: "/cuenta/servicio-de-salud-integral",
            current: pathName === "/cuenta/servicio-de-salud-integral" ? true : false,
        },
    ]
    const tabsHogarDetails = [
        {
            name: "Servicios Internet",
            href: "/cuenta/servicio-de-internet",
            current:
                pathName === "/cuenta/servicio-de-internet/detalle-internet" ? true : false,
        },
        {
            name: "Servicios Televisión",
            href: "/cuenta/servicio-de-television",
            current:
                pathName === "/cuenta/servicio-de-television/detalle-television"
                    ? true
                    : false,
        },
        {
            name: "Servicios Televisión Streaming",
            href: "/cuenta/servicio-de-streaming",
            current:
                pathName === "/cuenta/servicio-de-streaming/detalle-streaming" ? true : false,
        },
        {
            name: "Servicios Telefonía",
            href: "/cuenta/servicio-de-telefonia",
            current: pathName === "/cuenta/servicio-de-telefonia/detalle-telefonia" ? true : false,
        },
        {
            name: "Servicios Salud Integral",
            href: "/cuenta/servicio-de-salud-integral",
            current: pathName === "/cuenta/servicio-de-salud-integral/detalle-salud-integral" ? true : false,
        },
    ]
    const tabsEmpresaDetails = [
        {
            name: "Servicios Internet",
            href: "/cuenta/servicio-de-internet",
            current:
                pathName === "/cuenta/servicio-de-internet/detalle-internet" ? true : false,
        },
        {
            name: "Servicios Datos",
            href: "/cuenta/servicio-de-datos",
            current:
                pathName === "/cuenta/servicio-de-datos/detalle-datos"? true : false,
        },
        {
            name: "Servicios Televisión Streaming",
            href: "/cuenta/servicio-de-streaming",
            current:
                pathName === "/cuenta/servicio-de-streaming/detalle-streaming" ? true : false,
        },
        {
            name: "Servicios Telefonía",
            href: "/cuenta/servicio-de-telefonia",
            current: pathName === "/cuenta/servicio-de-telefonia/detalle-telefonia" ? true : false,
        },
        {
            name: "Servicios Salud Integral",
            href: "/cuenta/servicio-de-salud-integral",
            current: pathName === "/cuenta/servicio-de-salud-integral/detalle-salud-integral" ? true : false,
        },
    ]
    return { tabsHogar, tabsEmpresa, tabsHogarDetails, tabsEmpresaDetails }
}
